import React from 'react';
import { WxbButton } from '../Button/Button';
import { WxbDataTable } from '../DataTable/DataTable';
import { WxbDrawer } from '../Drawer/Drawer';
import { WxbTag } from '../Tag/Tag';
import type { GanttV5Task } from './types';

interface SelectionDrawerV5Props {
  open: boolean;
  tasks: GanttV5Task[];
  onClose: () => void;
  onRemove: (taskId: string) => void;
  onClear: () => void;
  actions?: React.ReactNode;
}

const SelectionDrawerV5: React.FC<SelectionDrawerV5Props> = ({
  open,
  tasks,
  onClose,
  onRemove,
  onClear,
  actions,
}) => (
  <WxbDrawer
    open={open}
    width={620}
    title="已选任务"
    destroyOnClose
    onClose={onClose}
    footer={(
      <div className="wxb-gantt-v5-selection-drawer__footer">
        <WxbTag color="blue">共 {tasks.length} 个任务</WxbTag>
        {actions}
        <WxbButton variant="ghost" disabled={tasks.length === 0} onClick={onClear}>清空选择</WxbButton>
      </div>
    )}
  >
    <WxbDataTable<GanttV5Task>
      rowKey="id"
      size="small"
      density="compact"
      pagination={{ pageSize: 30, showSizeChanger: true }}
      dataSource={tasks}
      columns={[
        { title: '任务', dataIndex: 'label', key: 'label' },
        { title: '开始', key: 'start', render: (_value, task) => `${task.start.toFixed(2)} h` },
        { title: '结束', key: 'end', render: (_value, task) => `${task.end.toFixed(2)} h` },
        { title: '人员', dataIndex: 'requiredPeople', key: 'requiredPeople', render: (value) => String(value ?? '—') },
        {
          title: '操作',
          key: 'action',
          render: (_value, task) => (
            <WxbButton variant="ghost" size="sm" onClick={() => onRemove(task.id)}>取消选择</WxbButton>
          ),
        },
      ]}
      locale={{ emptyText: '当前没有已选任务' }}
    />
  </WxbDrawer>
);

export default SelectionDrawerV5;
